// extracted by mini-css-extract-plugin
export default {"torrent":"Torrent_torrent__prXXp","size-download":"Torrent_size-download__hsGcb","icon":"Torrent_icon__MC1Bl"};